var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnacks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_190_4078",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H20V20H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_190_4078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4129 7.80205L9.99609 10.3259C11.0278 10.9173 11.9641 11.563 12.7942 12.2548C14.0633 13.313 15.2223 14.6993 16.0438 16.0591L17.2067 8.43565C17.2746 7.99107 16.8337 7.63678 16.4129 7.80205Z",
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6082 17.7254C13.9949 14.2215 10.2988 11.666 7.67378 10.4418C6.06652 9.69231 4.57539 9.20652 3.56812 8.92297C3.13718 8.80164 2.72492 9.16559 2.79246 9.60816L4.30191 19.5023C4.34566 19.7887 4.59175 20 4.88121 20H14.9398C15.2293 20 15.4753 19.7887 15.5191 19.5023C15.5191 19.5023 15.6449 17.8051 15.6082 17.7254Z",
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39844 4.32291C5.39844 4.03354 5.16383 3.79893 4.87445 3.79893H4.16457C3.8752 3.79893 3.64062 4.03354 3.64062 4.32291V7.69037C4.28555 7.83955 4.83121 7.99502 5.39844 8.1958V4.32291Z",
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13281 1.75212C8.13281 1.46274 7.8982 1.22814 7.60883 1.22814H6.89895C6.60957 1.22814 6.375 1.46274 6.375 1.75212V8.57544C6.88199 8.78716 7.44684 9.04298 8.13281 9.36255V1.75212Z",
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8672 0.524034C10.8672 0.234659 10.6326 4.95911e-05 10.3432 4.95911e-05H9.63332C9.34395 4.95911e-05 9.10938 0.234659 9.10938 0.524034V9.41919L10.8672 8.72427V0.524034Z",
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6016 4.32291C13.6016 4.03354 13.367 3.79893 13.0776 3.79893H12.3677C12.0783 3.79893 11.8438 4.03354 11.8438 4.32291V8.34033L13.6016 7.64893V4.32291Z",
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3359 6.61372V3.0029C16.3359 2.71353 16.1013 2.47896 15.812 2.47896H15.1021C14.8127 2.47896 14.5781 2.71353 14.5781 3.0029V7.26489C16.1153 6.66032 16.099 6.65411 16.3359 6.61372Z",
    fill: "#E9A5F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnacks);
export default __webpack_public_path__ + "static/media/snacks.04d445a1d3fd561edb730d2cdc040c07.svg";
export { ForwardRef as ReactComponent };